export default "__VITE_ASSET__BOlUf8kq__"